module.exports = __webpack_public_path__ + "img/image-down.ba7dfa17.svg";